export default __webpack_public_path__ + "static/media/imbtc-mta.dfd9ddb2.svg";